// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2UtX9","title":"ClientReferral_title__lx90r","itemText":"ClientReferral_itemText__3VCuf"};